<!--问卷中心主页面-->
<template>
  <div class="Questionnaire_context">
    <div class="Questionnaire_type">
      <span class="Questionnaire_type_title">题型</span>
      <hr />
      <div>
        <span class="Questionnaire_type_selectTitle">选择题</span>
        <div class="Question_Type_Seclect">
          <div
            class="QuestionType"
            @click.prevent="QuestionnaireAddClick(0)"
          >
            <a
              href="javascript:void(0);"
              style="color: #707070"
            >
              <img
                class="Question_Type_Seclect_img"
                src="../../assets/SingleChoice.png"
              />
              <span>单选题</span>
            </a>
          </div>
          <div
            class="QuestionType"
            @click.prevent="QuestionnaireAddClick(1)"
          >
            <a
              href="javascript:void(0);"
              style="color: #707070"
            >
              <img
                class="Question_Type_Seclect_img"
                src="../../assets/MultipleChoice.png"
              />
              <span>多选</span>
            </a>
          </div>
        </div>
      </div>
      <div>
        <span class="Questionnaire_type_selectTitle">简单题</span>
        <div>
          <div
            class="QuestionType"
            @click.prevent="QuestionnaireAddClick(2)"
          >
            <a
              href="javascript:void(0);"
              style="color: #707070"
            >
              <img
                class="Question_Type_Seclect_img"
                src="../../assets/simple.png"
              />
              <span>简答</span>
            </a>
          </div>
        </div>
      </div>

      <div class="Question_Type_Save">
        <el-button
          @click="goback"
          class="Question_Type_BackButton"
        >返回</el-button>
        <el-button
          class="Question_Type_SaveButton"
          type="primary"
          @click="SavaQuestionnaire"
          v-show="data.operation!='Detail'"
        >保存</el-button>
      </div>
    </div>

    <div class="Questionnaire_SetContext">
      <div class="Questionnaire_SetContext_title" :class="data.operation=='Detail'?'form_Readonly':''" >
        <el-input
          class="data_Title"
          v-model="data.Questionnaire.title"
        />
        <el-input v-model="data.Questionnaire.subtitle" />
      </div>

      <div
        class="Questionnaire_SetContext_context"
        :class="Questionnaire_Border"
      >
        <div
          v-if="data.QuestionTopicData.length <= 0"
          class="Questionnaire_SetContext_context_defult"
        >
          <span>
            <el-icon>
              <pointer />
            </el-icon> 请点击题型
          </span>
        </div>
        <div v-else>
          <draggable
            v-model="data.QuestionTopicData"
            chosenClass="chosen"
            forceFallback="true"
            group="people"
            animation="1000"
            @start="onStart"
            @end="onEnd"
          >
            <div
              v-for="(item, index) in data.QuestionTopicData"
              :key="index"
            >
              <QuestionnaireSimple
                @DocumentCopy="DocumentCopy"
                @DeleteFilled="DeleteFilled"
                @click="QuestionnaireSimpleClick(index)"
                :dataindex="index"
                :operation="data.operation"
                v-if="item.type == 2"
                :item="item"
              ></QuestionnaireSimple>
              <QuestionnaireChoice
                @DocumentCopy="DocumentCopy"
                @DeleteFilled="DeleteFilled"
                @click="QuestionnaireSimpleClick(index)"
                :dataindex="index"
                v-else
                :item="item"
                :operation="data.operation"
              ></QuestionnaireChoice>
            </div>
          </draggable>
        </div>
      </div>
      <div class="Questionnaire_SetContext_bottom">
        <div class="Questionnaire_SetContext_bottom_context">
          <span>完成时显示</span>
          <el-input v-model="data.tiptitle"></el-input>
          <el-button
            v-show="data.operation!='Detail'"
            type="primary"
            class="issuebtn"
            @click="SavaQuestionnaire(1)"
          >
            <el-icon style="margin-right: 3px">
              <promotion />
            </el-icon>审核
          </el-button>
        </div>
      </div>
    </div>

    <div class="Questionnaire_SetOverall">
      <el-tabs
        v-model="activeName"
        type="card"
        class="demo-tabs"
        @tab-click="handleClick"
      >
        <el-tab-pane
          label="全局设置"
          class="Questionnaire_SetOverall_pane"
          :class="data.operation=='Detail'?'form_Readonly':''" 
        >
          <div class="Questionnaire_SetOverall_Global">
            <span>题目序号</span>
            <el-switch
              v-model="data.Questionnaire.serialnumber"
              class="ml-2"
              :active-value="1"
              :inactive-value="0"
              active-color="#0747a6"
              inactive-color="#707070"
            />
          </div>
          <div class="Questionnaire_SetOverall_Global">
            <span>随机顺序</span>
            <el-switch
              v-model="data.Questionnaire.isRandom"
              class="ml-2"
              :active-value="true"
              :inactive-value="false"
              active-color="#0747a6"
              inactive-color="#707070"
            />
          </div>

          <div class="Questionnaire_SetOverall_Global">
            <span>批量删除</span>
            <el-button
              type="text"
              class="Questionnaire_SetOverall_Global_Set"
              @click="DeleShow"
            >设置</el-button>
          </div>

          <div class="Questionnaire_SetOverall_Global">
            <span>调研对象</span>
            <el-button
              type="text"
              @click="QuestionnaireObjShow"
              class="Questionnaire_SetOverall_Global_Set"
            >设置</el-button>
          </div>

          <div class="Questionnaire_SetOverall_Global_Time">
            <span>开始时间</span>
            <el-date-picker v-model="data.Questionnaire.startDate" type="date" placeholder="年/月/日" size="small" format="YYYY-MM-DD"/>
          </div>
          <div class="Questionnaire_SetOverall_Global_Time">
            <span>结束时间</span>
            <el-date-picker v-model="data.Questionnaire.endDate" type="date" placeholder="年/月/日" size="small" format="YYYY-MM-DD"/>
          </div>

        </el-tab-pane>
        <el-tab-pane
          label="题目设置"
          class="Questionnaire_SetOverall_pane"
          :disabled="data.disabled"
          :class="data.operation=='Detail'?'form_Readonly':''" 
        >
          <div
            class="Questionnaire_SetOverall_tip"
            v-if="data.currentTopic != null"
          >
            <span>Q{{ data.currentTopic.number }} 题目设置</span>
            <h1 class="Questionnaire_SetOverall_title">{{ TipText }}</h1>
          </div>
          <span class="Questionnaire_SetOverall_title">整题设置</span>
          <hr />
          <div
            class="Questionnaire_SetOverall_Global"
            v-if="data.currentTopic != null"
          >
            <span>切换题型</span>
            <el-select
              v-model="data.currentTopic.type"
              class="m-2 Questionnaire_SetOverall_titleType"
              placeholder="单选"
              size="mini"
              @change="TipTypeChange"
            >
              <el-option
                key="0"
                label="单选"
                :value="0"
              > </el-option>
              <el-option
                key="1"
                label="多选"
                :value="1"
              > </el-option>
              <el-option
                key="2"
                label="简答"
                :value="2"
              > </el-option>
            </el-select>
          </div>
          <div
            class="Questionnaire_SetOverall_Global"
            v-if="data.currentTopic != null"
          >
            <span>此题必答</span>
            <el-switch
              v-model="data.currentTopic.isMust"
              class="ml-2"
              :active-value="true"
              :inactive-value="false"
              active-color="#0747a6"
              inactive-color="#707070"
            />
          </div>
          <div
            class="Questionnaire_SetOverall_Global"
            v-if="data.currentTopic != null"
          >
            <span>显示序号</span>
            <el-switch
              v-model="data.currentTopic.Serialnumber"
              :active-value="true"
              :inactive-value="false"
              class="ml-2"
              active-color="#0747a6"
              inactive-color="#707070"
            />
          </div>
          <div
            class="Questionnaire_SetOverall_Global"
            v-if="data.currentTopic != null"
          >
            <span>填写提示</span>
            <el-switch
              v-model="data.currentTopic.ishint"
              :active-value="true"
              :inactive-value="false"
              class="ml-2"
              active-color="#0747a6"
              inactive-color="#707070"
            />
          </div>
          <span class="Questionnaire_SetOverall_title"> 填写限制 </span>
          <hr />
          <div
            class="Questionnaire_SetOverall_Global"
            v-if="data.currentTopic != null"
          >
            <span>最少填写</span>
            <div>
              <el-input
                class="Questionnaire_SetOverall_titleType"
                size="mini"
                v-model="data.currentTopic.minLength"
              />
              <span>字</span>
            </div>
          </div>
          <div
            class="Questionnaire_SetOverall_Global"
            v-if="data.currentTopic != null"
          >
            <span>最多填写</span>
            <div>
              <el-input
                class="Questionnaire_SetOverall_titleType"
                size="mini"
                v-model="data.currentTopic.maxLength"
              />
              <span>字</span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <DeleteQuestionnaire
      v-if="dialogVisible"
      :dialogVisible="dialogVisible"
      v-model:DataList.sync="data.QuestionTopicData"
      @handleClose="handleClose"
      @submit="submit"
    ></DeleteQuestionnaire>

    <QuestionDataDetailList
      ref="QuestionDataDetailRef"
      v-model:QuestionnaireObjectSetDialogVisible="QuestionnaireObjectSetDialogVisible"
      v-model:parentcode="parentcode"
      @handleCancel="handleCancel"
      @handleConfirm="handleConfirm"
    ></QuestionDataDetailList>

  </div>
</template>

<script setup>
import {
  AddQuestionnaire,
  ModifyQuestionnaire,
  SelectQuestionnairetById,
  SelectQuestionnairetDetailById,
} from "@api/Questionnaire";
import QuestionnaireSimple from "./common/QuestionnaireSimple";
import QuestionnaireChoice from "./common/QuestionnaireChoice";
import DeleteQuestionnaire from "../../components/QuestionnaireCenter/DeleteQuestionnaire.vue";
import QuestionDataDetailList from "../../components/QuestionnaireCenter/QuestionDataDetailList.vue";

import { reactive, ref, computed, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElLoading } from "element-plus";
import { dateFormat, dateCompare } from "@/util/utils.js";
import { getUserInfo } from "@/util/authority";

/* 自定义变量 */
const dialogVisible = ref(false);
const QuestionnaireObjectSetDialogVisible = ref(false);
const userinfo = getUserInfo();

const handleClose = () => {
  dialogVisible.value = false;
};

const submit = (item) => {
  data.QuestionTopicData.splice(1, 1);
  dialogVisible.value = false;
  console.log("data.QuestionTopicData",data.QuestionTopicData);
};
const DeleShow = () => {
  dialogVisible.value = true;
};
const parentcode = ref("父组件中的值")

const QuestionDataDetailRef = ref(null)
const QuestionnaireObjShow=()=>{
  var id=0
  if (data.operation == "Edit")id=data.Questionnaire.id
  QuestionDataDetailRef.value.loadDefaulData(data.Questionnaire.range.toString(),id)
  QuestionnaireObjectSetDialogVisible.value = true;
};
const handleCancel=()=>{
   QuestionnaireObjectSetDialogVisible.value = false;
};
const handleConfirm= (obj)=>{
   QuestionnaireObjectSetDialogVisible.value = false;

   debugger

   data.Questionnaire.range=obj.range
   data.Questionnaire.questionObjects=[]

   if(obj.range=="1"||obj.range=="2")
   {
    obj.ids.forEach(x=>{
      var entity={}
      entity.id=0
      entity.companyId=0
      if(obj.range=="1")entity.departmentId=x
      if(obj.range=="2")entity.userId=x

      data.Questionnaire.questionObjects.push(entity)
    })
   }
};

const router = useRouter();
const data = reactive({
  Questionnaire: {
    title: "标题",
    range: 0, //默认 公司
    status: 0, //默认已创建
    startDate: "",
    endDate: "",
    isRandom: false,
    serialnumber: 0,
    subtitle: "感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！",
    companyId: userinfo.CompanyId,
    companyName: "",
    questionTopics: [],//题目
    questionObjects:[],//调研对象
  },
  tiptitle: "您已完成本次问卷,感谢您的帮助与支持",
  disabled: true,
  currentIndex: 0, //选中题目
  currentTopic: null,
  QuestionTopicData: [],
  operation: "New", //当前状态(新增，修改，查看)
  mainId: "", //问卷主表ID
});
let Questionnaire_Border = ref("Questionnaire_Border");

/* 方法 */
//返回
const goback = () => {
  router.replace({
    name: "问卷管理",
    params: {
      from: "QuestionnaireEdit",
      isReplace: true,
    },
  });
};

//保存
const SavaQuestionnaire = (type = 0) => {
  if(!CheckSave()) return;
  //保存成功后跳回列表页面
  const loading = ElLoading.service({
    lock: true,
    text: "问卷保存中...",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.9)",
  });
  let Questiondata = data.Questionnaire;
  if (type == 1) {
    //审核
    Questiondata.status = 1;
  }
  //题目表
  let questionTopics = [];
  data.QuestionTopicData.forEach((item) => {
    questionTopics.push(item);
  });
  Questiondata.questionTopics = questionTopics;

  if (data.operation == "Edit") {
    ModifyQuestionnaire(Questiondata)
      .then((res) => {
        loading.close();
        ElMessage.success("保存成功！");
        goback();
      })
      .catch((error) => {
        loading.close();
        ElMessage.error("修改保存失败!" + error);
      });
  } else {
    AddQuestionnaire(Questiondata)
      .then((res) => {
        loading.close();
        ElMessage.success("保存成功！");
        goback();
      })
      .catch((error) => {
        loading.close();
        ElMessage.error("保存失败!" + error);
      });
  }
};
const CheckSave = () => {
  if(data.Questionnaire.title.trim() == "") {
    ElMessage.warning("请输入问卷标题");
    return false;
  }
  let { startDate, endDate } = data.Questionnaire;
  if(dateCompare(startDate,endDate,2)) {
    ElMessage.warning("问卷开始时间不能大于结束时间！");
    return false;
  }
  return true;
}

//切换题型
const TipTypeChange = (value) => {
  data.currentTopic.type = value;
};

//添加题目
const QuestionnaireAddClick = (type) => {
  if(data.operation=='Detail')return
  let Questionnaire = {
    title: type == 2 ? "请简答以下题目" : "请选择一个选项",
    type: type,
    number: data.QuestionTopicData.length + 1,
    hint: "",
    isRandom: false,
    isMust: true,
    minLength: 1,
    maxLength: 100,
    questionOptions:
      type == 2
        ? []
        : [
            {
              name: "选项1",
              isDefault: false,
              number: 1,
            },
          ],
  };
  if (data.operation == "Edit") {
    Questionnaire.questionId = data.mainId;
  }
  data.QuestionTopicData.push(Questionnaire);
  data.currentIndex = Questionnaire.number;
};

//切换当前题型
const QuestionnaireSimpleClick = (index) => {
  //1.切换题型
  data.disabled = false;
  data.currentIndex = index;
  //2.切换当前题的设置信息
  data.currentTopic = data.QuestionTopicData[index];
};
//复制
const DocumentCopy = (CopyItem) => {
  let Currtitem = JSON.parse(JSON.stringify(CopyItem));
  Currtitem.number = data.QuestionTopicData.length + 1;
  if (data.operation == "Edit") {
    //修改页面时复制题目
    delete Currtitem.id;
    if (Currtitem.questionOptions.length > 0) {
      Currtitem.questionOptions.forEach((item) => {
        delete item.id;
        delete item.questionTopicId;
      });
    }
  }
  data.QuestionTopicData.push(Currtitem);
  data.currentIndex = Currtitem.number;
  ElMessage.success("复制成功!");
};
//删除
const DeleteFilled = (index) => {
  data.QuestionTopicData.splice(index, 1);
  //删除后重置序号
  for(let i = 0;i < data.QuestionTopicData.length;i ++) {
    let item = data.QuestionTopicData[i];
    item.number = i + 1;
  }
  ElMessage.success("删除成功!");
};

/* 生命周期 */
onMounted(() => {
  let currentroute = router.currentRoute.value;
  if (currentroute.params.hasOwnProperty("senddata")) {
    //跳转过来携带的参数
    let { operation, mainId } = JSON.parse(currentroute.params.senddata);
    data.operation = operation;
    data.mainId = mainId;
  }
  initData();
});

/** 界面初始化 */
async function initData() {
  if (data.mainId) {
    const Questionnaire = SelectQuestionnairetById(data.mainId);
    const QuestionnaireDeitl = SelectQuestionnairetDetailById(data.mainId);
    Promise.all([Questionnaire, QuestionnaireDeitl])
      .then((result) => {
        data.Questionnaire = result[0];
        data.QuestionTopicData = result[1];
      })
      .catch((error) => console.log(error))
      .finally((error) => console.log(error));
  } else {
    var date1 = new Date();
    var date2 = new Date(date1);
    date2.setDate(date1.getDate() + 30);
    data.Questionnaire.startDate = dateFormat("YYYY-mm-dd", date1);
    data.Questionnaire.endDate = dateFormat("YYYY-mm-dd", date2);
  }
}

//监听是否存在题目
watch(
  () => data.QuestionTopicData,
  (before, after) => {
    if (data.QuestionTopicData.length == 0) {
      data.disabled = true;
      Questionnaire_Border.value = "Questionnaire_Border";
    } else Questionnaire_Border.value = "";
  },
  {
    deep: true, // 深度监听的参数
  }
);
//监听当前题设置发生变化时改变对应题的值
watch(
  () => data.currentIndex,
  (before, after) => {
    if (data.QuestionTopicData[data.currentIndex] != null) {
      data.currentTopic = data.QuestionTopicData[data.currentIndex];
    }
  },
  {
    deep: true, // 深度监听的参数
  }
);

const TipText = computed(() => {
  switch (data.currentTopic.type) {
    case 0:
      return "单选题";
    case 1:
      return "多选题";
    case 2:
      return "简答题";
  }
  return "";
});
</script>

<style lang="scss" scoped>
.form_Readonly {
  pointer-events: none;
}
.Questionnaire_context {
  display: flex;
  //height: 100%;
  min-height: 600px;
  font-size: 20px;
  // color: #24335A;
  font-family: PingFang SC-Regular;

  .Questionnaire_type {
    width: 224px;
    position: relative;
    background-color: #ffffff;
    padding: 0 10px;

    .Questionnaire_type_title {
      font-size: 16px;
      font-weight: 700;
      color: #000000;
      margin-left: 10px;
      display: inline-block;
      line-height: 70px;
      height: 67px;
    }

    .Questionnaire_type_selectTitle {
      font-size: 16px;
      font-weight: 500;
      margin: 10px 0px 8px 10px;
      color: #33404e;
      display: inline-block;
      line-height: 20px;
      height: 20px;
    }

    .Question_Type_Seclect {
      display: flex;
      justify-content: flex-start;
    }

    .Question_Type_Seclect_img {
      width: 20px;
      height: 20px;
    }

    .QuestionType {
      border: solid 1px #707070;
      background-color: #ffffff;
      border-radius: 2px;
      padding: 0 5px;
      width: 80px;
      height: 30px;
      margin-left: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      span {
        margin-left: 10px;
      }

      a {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 30px;
      }
    }

    .QuestionType:hover {
      border: solid 1px blue;
      color: blue;
      background-color: #f0e7e7ad;
    }

    .Question_Type_Save {
      position: absolute;
      left: 20px;
      bottom: 18px;
      .Question_Type_BackButton {
        width: 87px;
        max-height: 40px;
        min-height: 40px;
        background: #ffffff;
        border-radius: 2px 2px 2px 2px;
        font-size: 14px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #202020;
        line-height: 32px;
        padding: 0;
        border: solid 1px #707070;
      }
      .Question_Type_SaveButton {
        width: 87px;
        max-height: 40px;
        min-height: 40px;
        background: #0747a6;
        border-radius: 2px 2px 2px 2px;
        font-size: 14px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 32px;
        padding: 0;
        border: solid 1px;
      }
    }

    hr {
      height: 1px;
      background-color: #d8dee8;
      border: none;
    }
  }

  .Questionnaire_SetContext {
    width: 80%;
    // height: 100%;
    // background-color: gold;
    padding: 0 20px;

    .Questionnaire_SetContext_title {
      //height: 20%;
      padding: 10px 20px;
      background-color: #ffffff;
    }

    .Questionnaire_SetContext_context {
      // height: 50%;
      min-height: 300px;
      margin: 10px 0;
      //border: dashed 1px #707070;
      position: relative;

      .Questionnaire_SetContext_context_defult {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .Questionnaire_SetContext_bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      min-height: 100px;

      // height: 20%;
      .Questionnaire_SetContext_bottom_context {
        text-align: center;
        margin-top: 34px;
        margin-bottom: 19px;
        .issuebtn {
          width: 90px;
          max-height: 32px;
          min-height: 32px;
          background: #0747a6;
          border-radius: 2px 2px 2px 2px;
          font-size: 14px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #ffffff;
          line-height: 32px;
          padding: 0;
        }
      }

      .Questionnaire_SetContext_bottom_context span {
        display: inline-block;
        font-size: 14px;
        color: #33404e;
        //background-color: red;
      }
    }
  }

  .Questionnaire_SetOverall {
    height: 100%;
    background-color: #ffffff;
    .Questionnaire_SetOverall_pane {
      padding: 0 5px;
      hr {
        height: 1px;
        background-color: #d8dee8;
        border: none;
      }
    }

    .Questionnaire_SetOverall_Global {
      //  background-color: chartreuse;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 10px;
      border-bottom: solid 1px #d8dee8;
      .Questionnaire_SetOverall_Global_Set {
        color: #0747a6;
        max-height: 21px;
        min-height: 21px;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        line-height: 21px;
        padding: 0;
      }
    }

    .Questionnaire_SetOverall_Global span {
      font-size: 16px;
      color: #24335a;
    }

    .Questionnaire_SetOverall_titleType {
      width: 75px;
      color: red;
    }

    .Questionnaire_SetOverall_title {
      display: inline-block;
      font-size: 16px;
      font-weight: 600;
      color: #24335a;
      padding: 10px 10px;
    }

    .Questionnaire_SetOverall_tip {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}

.Questionnaire_Border {
  border: dashed 1px #707070;
}

.Questionnaire_SetOverall_Global_Time {
  //  background-color: chartreuse;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px;
  border-bottom: solid 1px #d8dee8;
}

.Questionnaire_SetOverall_Global_Time span {
  font-size: 16px;
  color: #24335a;
  width: 70px;
}
</style>

<style scoped>
.Questionnaire_SetContext_title /deep/ .el-input__inner {
  font-size: 16px;
  line-height: 50px;
  color: #262a33;
  background-color: #ffffff;
  border: 0;
}

.Questionnaire_SetContext_title /deep/ .el-input__inner:focus {
  line-height: 50px;
  color: #f0f2f5;
  background-color: #b7bfc5;
  border: 0;
}

.data_Title /deep/ .el-input__inner {
  font-size: 20px;
  color: #262a33;
}
.Questionnaire_SetContext_bottom_context /deep/ .el-input__inner {
  font-size: 16px;
  color: #262a33;
  font-weight: 700;
  text-align: center;
  border: 0;
  margin: 10px 0;
}
.Questionnaire_SetContext_bottom_context /deep/ .el-input__inner:focus {
  border: dashed 1px #707070;
}

.demo-tabs /deep/ .el-tabs__item.is-active {
  color: #0747a6;
  font-family: PingFang SC-Regular;
  font-size: 16px;
}
.demo-tabs /deep/ .el-tabs__item:hover {
  color: #0747a6;
  cursor: pointer;
}
.Questionnaire_SetOverall_Global_Time /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 125px;
}
.Questionnaire_SetOverall_Global_Time /deep/ .el-input--suffix .el-input__inner {
  padding-right: 20px;
}
</style>


